module.exports = __webpack_public_path__ + "static/img/02bg@2x.bda26d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toolbar/02bg@2x.png
// module id = 2LWh
// module chunks = 1